import { useMutation } from "@apollo/react-hooks";
import { Button, Col, Form, Input, message, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import useDigitInput from "react-digit-input";
import { useHistory } from "react-router";
import OTPVerificationImage from "../../../Assets/Images/003.jpg";
import { CustIcon } from "../../../Components/Svgs";
import { RESEND_OTP, VERIFY_OTP } from "../../../Graphql/mutations";

const { Title } = Typography;

export const OtpVerificationPage = () => {
  const history = useHistory();

  const [seconds, setSeconds] = useState(30);
  const [value, onChange] = useState("");
  const [firstOtpSend, setFirstOtpSend] = useState(true);

  const [VERIFY_OTP_MUTATION, { loading: isVerifying }] = useMutation(
    VERIFY_OTP,
    {
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );
  const [RESEND_OTP_MUTATION, { loading: resending }] = useMutation(
    RESEND_OTP,
    {
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );

  useEffect(() => {
    if (firstOtpSend) {
      handleResendOtp();
      setFirstOtpSend(false);
    }
  }, [firstOtpSend]);

  useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    }
  }, [seconds]);

  const digits = useDigitInput({
    acceptedCharacters: /^[0-9]$/,
    length: 6,
    value,
    onChange,
  });

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const tailLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  const handleResendOtp = async () => {
    try {
      const payload = {
        token: localStorage.getItem("sanattest_access_token"),
      };
      const response = await RESEND_OTP_MUTATION({
        variables: payload,
      });

      if (!response.error) {
        message.success(`${response?.data?.resend_otp?.message}`);
        setSeconds(30);
      }
    } catch (error) {
      message.error("Something went wrong...");
    }
  };

  const onFinish = async () => {
    try {
      const payload = {
        user_id: localStorage.getItem("user_id"),
        otp: value,
      };
      const response = await VERIFY_OTP_MUTATION({
        variables: payload,
      });

      if (response.data?.verify_otp?.status === "OK") {
        message.success(`${response?.data?.verify_otp?.message}`);
        history.push(history.location.state.nextPage);
      } else {
        message.error(`${response?.errors[0]?.message}`);
      }
    } catch (error) {
      message.error("Something went wrong...");
    }
  };

  return (
    <div className="rowSec">
      <div className="colSec onBoardingLeft">
        <img src={OTPVerificationImage} alt="" className="" />
      </div>
      <div className="colSec onBoardingRight">
        <div className="step_5">
          <p className="text-right text-step">Step 2 of 6</p>
          <Title level={2}>
            <CustIcon type="left-arrow" onClick={() => history.goBack()} />
            Verify your account
          </Title>
          <p className="subTitle">
            Enter the 6 digit verification code sent on your{" "}
            <strong>Email</strong> to verify your account .
          </p>

          <Form {...layout} name="basic">
            <Row gutter={16}>
              <Col>
                <Form.Item label="Enter 6 digit code" name="code">
                  <Row gutter={7}>
                    <Col>
                      <Input
                        maxLength="1"
                        placeholder="0"
                        inputMode="decimal"
                        autoFocus
                        {...digits[0]}
                      />
                    </Col>
                    <Col>
                      <Input
                        maxLength="1"
                        placeholder="0"
                        inputMode="decimal"
                        {...digits[1]}
                      />
                    </Col>
                    <Col>
                      <Input
                        maxLength="1"
                        placeholder="0"
                        inputMode="decimal"
                        {...digits[2]}
                      />
                    </Col>
                    <Col>
                      <Input
                        maxLength="1"
                        placeholder="0"
                        inputMode="decimal"
                        {...digits[3]}
                      />
                    </Col>
                    <Col>
                      <Input
                        maxLength="1"
                        placeholder="0"
                        inputMode="decimal"
                        {...digits[4]}
                      />
                    </Col>
                    <Col>
                      <Input
                        maxLength="1"
                        placeholder="0"
                        inputMode="decimal"
                        {...digits[5]}
                      />
                    </Col>
                  </Row>
                </Form.Item>
              </Col>
            </Row>
            <Form.Item {...tailLayout} className="buttonSec">
              <Button
                type="primary"
                shape="round"
                size="large"
                htmlType="button"
                loading={isVerifying}
                onClick={() => onFinish(value)}
              >
                Submit
              </Button>
              <Button
                htmlType="button"
                shape="round"
                onClick={() => handleResendOtp()}
                className="ml-3"
                size="large"
                loading={resending}
                disabled={seconds > 0}
              >
                Resend Code {seconds > 0 ? `in ${seconds}s` : null}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};
